import { SharingTipId } from '../../types/sharingTipId';
import { assertNever } from 'owa-assert';
import { InfoBarMessageRank } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

// Note: linkHasExpired and externalRecipientCSL are the only two cases were we are certain that recipients won't have access
// for noPermissionToShare/externally, and sharingWithLargeDL there is a reasonable chance of no access, but not a garuntee,
// and we are currently erring on the side of error instead of info
// getSharingInfoFailed, linkWillExpire, and noPermissionSet are reasonable user choices, so we show info instead of error.
export function getInfoBarMessageRank(sharingTipId: SharingTipId): InfoBarMessageRank {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.sharingWithLargeDL:
        case SharingTipId.linkHasExpired:
        case SharingTipId.externalRecipientCSL:
        case SharingTipId.noPermissionSet:
            return InfoBarMessageRank.Error;
        case SharingTipId.linkWillExpire:
        case SharingTipId.getSharingInfoFailed:
            return InfoBarMessageRank.Info;
        default:
            return assertNever(sharingTipId);
    }
}
